import { render, staticRenderFns } from "./singleAdministrationChildrenFirstVoidEdit.vue?vue&type=template&id=40c9775e"
import script from "./singleAdministrationChildrenFirstVoidEdit.vue?vue&type=script&lang=js"
export * from "./singleAdministrationChildrenFirstVoidEdit.vue?vue&type=script&lang=js"
import style0 from "./singleAdministrationChildrenFirstVoidEdit.vue?vue&type=style&index=0&id=40c9775e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports